import {
  Box,
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PageLoader = ({ open, message }) => {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: { xs: 2, sm: 3, md: 4 },
      }}
    >
      {/* Content Blur Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,         
          background: "rgba(38, 38, 38, 0.5)",
        }}
      />

      {/* Loader Dialog */}
      <Dialog
        open={open}
        disablePortal
        hideBackdrop
        slotProps={{
          paper: {
            sx: {
              borderRadius: "12px",                     
              width: { xs: "280px", sm: "398px" },
              margin: 0,
              border:'1px',
              p: '32px' ,  
            },
          },
        }}
        sx={{
          zIndex: 2,
          "& .MuiBackdrop-root": {
            display: "none",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,            
            gap: { xs: 1.5, sm: 3 },
          }}
        >
          <CircularProgress 
          
          />
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "20px"},
              fontWeight: 600,             
              textAlign: "center",              
              overflowWrap: "break-word",
            }}
          >
            {message ? message : t("loader-messages.page-loading.title")}
          </Typography>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default PageLoader;

PageLoader.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};